/* eslint-disable no-case-declarations */
import React, { useEffect } from "react"
import { HMSNotificationTypes, useHMSNotifications } from "@100mslive/react-sdk"
import { useWebinarAppContext } from "../../state"
import { ReconnectNotifications } from "./reconnect-notifications"
import { useSubscribedNotifications } from "../app-data/use-uisettings"
import { useToast } from "../hooks/useToast"

export function Notifications() {
  const notification = useHMSNotifications()
  const { leaveMeeting } = useWebinarAppContext()
  const subscribedNotifications = useSubscribedNotifications() || {}
  const toast = useToast()
  useEffect(() => {
    if (!notification) {
      return
    }
    switch (notification.type) {
      case HMSNotificationTypes.NAME_UPDATED:
        toast.info("Your name has been changed")
        break
      case HMSNotificationTypes.ROOM_ENDED:
        toast.info(
          `${notification.message}. 
              ${notification.data.reason && `Reason: ${notification.data.reason}`}`,
        )
        setTimeout(() => {
          leaveMeeting()
          toast.clearAllToast()
        }, 2000)
        break
      default:
        break
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notification, subscribedNotifications.ERROR, subscribedNotifications.METADATA_UPDATED])

  return <ReconnectNotifications />
}
